import { render, staticRenderFns } from "./PreSalesAddNew.vue?vue&type=template&id=ca7124ea&scoped=true"
import script from "./PreSalesAddNew.vue?vue&type=script&lang=js"
export * from "./PreSalesAddNew.vue?vue&type=script&lang=js"
import style0 from "./PreSalesAddNew.vue?vue&type=style&index=0&id=ca7124ea&prod&lang=scss"
import style1 from "./PreSalesAddNew.vue?vue&type=style&index=1&id=ca7124ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7124ea",
  null
  
)

export default component.exports